import React, { useState, useEffect } from "react";
import {
  TextField,
  List,
  ListItem,
  ListItemText,
  Typography,
  InputAdornment,
  Box,
  Paper,
} from "@mui/material";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";

const SearchBar = () => {
  const [clients, setClients] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedClient, setSelectedClient] = useState(null);
  const navigate = useNavigate();

  const renderListClients = async () => {
    try {
      const response = await ApiMethods.get("client");
      console.log(response, "Response");
      setClients(response);
    } catch (err) {
      console.error("Error fetching clients:", err);
    }
  };

  useEffect(() => {
    renderListClients();
  }, []);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredClients = clients.filter((client) => {
    if (client.first_name || client.last_name) {
      return (
        client.first_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        client.last_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
    return false;
  });

  const handleClientClick = (client) => {
    console.log("Client clicked:", client);
    setSelectedClient(client);
    navigate(`/user_details/${client.id}`, { state: { client } });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#e0e0e0",
        padding: "16px",
      }}
    >
      {/* Sticky Search Bar */}
      <Paper
        sx={{
          position: "sticky", // Make the search bar sticky
          top: 0, // Stick to the top when scrolling
          zIndex: 10, // Ensure the search bar stays above other content
          width: "100%",
          maxWidth: "500px",
          padding: "16px",
          backgroundColor: "#fafafa",
          boxShadow: 3,
          borderRadius: "8px",
          marginBottom: "16px",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            marginBottom: "16px",
            color: "#333",
            fontWeight: "bold",
          }}
        >
          Search Clients
        </Typography>

        <TextField
          label="Search Clients"
          variant="outlined"
          fullWidth
          value={searchQuery}
          onChange={handleSearchChange}
          sx={{
            marginBottom: "16px",
            textAlign: "center",
            backgroundColor: "#f0f0f0",
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "gray" }} />
              </InputAdornment>
            ),
          }}
          inputProps={{
            style: {
              color: "gray",
            },
          }}
        />
      </Paper>

      {/* List of Clients without Scroll */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "500px",
          backgroundColor: "#fafafa",
          borderRadius: "8px",
          boxShadow: 3,
          paddingBottom: "16px",
        }}
      >
        <List sx={{ padding: 0 }}>
          {filteredClients.map((client) => (
            <ListItem
              key={client.id}
              onClick={() => handleClientClick(client)}
              sx={{
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
                padding: "8px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <ListItemText
                primary={`${client.first_name} ${client.last_name}`}
                sx={{ color: "black", fontSize: "14px" }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      {selectedClient && (
        <div style={{ marginTop: "16px" }}>
          <Typography variant="h6">Client Details:</Typography>
          <Typography>
            Name: {selectedClient.first_name} {selectedClient.last_name}
          </Typography>
        </div>
      )}
    </Box>
  );
};

export default SearchBar;
